<ng-container>
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="table-area" *ngIf="!isLoading">
    <div class="content-body table-container">
      <table class="table-header" sortable-table="sortable-table" (sorted)="sortTableByColumn($event)">
        <colgroup>
          <col *ngFor="let col of deviceTableHeader" [width]="col.width"/>
        </colgroup>
        <thead>
          <tr>
            <th *ngFor="let header of deviceTableHeader" [sortable-column]="header.value" [ngClass]="header?.tooltip ? 'flex v-center' : ''">
               {{header.name}}
              <div class="--g-tooltip-content" *ngIf="header?.tooltip" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')">
                <comp-icon class="--g-tooltip-icon" [icon]="'info'" [size]="16" [color]="'#4f566b'"></comp-icon>
                <div class="--g-tooltip" style="text-transform: none" *ngIf="header.tooltip === 'skipped'">This feature applies only when the motion score feature is enabled. <br/>Additionally, this value is not included in AI request counts. Skipped events will be delivered to the Central station just like traditional video events.</div>
                <div class="--g-tooltip" style="text-transform: none" *ngIf="header.tooltip === 'billable'">Number of AI events counted toward billing. This matches the Video AI Charges quantity on the invoice, while AI EVENTS is the total number of AI events regardless of billing.</div>
              </div>
            </th>
          </tr>
        </thead>
      </table>
      <div class="table-body">
        <table>
          <colgroup>
            <col *ngFor="let col of deviceTableHeader" [width]="col.width"/>
          </colgroup>
          <tbody>
            <tr *ngIf="pagedItems?.length === 0 && !isLoading" style="text-align: center; color: #999;">
              <td [attr.colspan]="deviceTableHeader.length">{{ this.searchText.length != 0 && this.searchText.length < 3 ? 'Please enter at least 3 characters' : 'No Device'}}</td>
            </tr>
            <ng-container *ngIf="!isLoading">
              <tr *ngFor="let device of pagedItems">
                <td>{{device.zone_number}}</td>
                <td [class.unknown]="device.dealer_name === 'No Name'">{{device.dealer_name}}</td>
                <td [class.unknown]="device.site_name === 'No Site Name'">{{device.site_name}}</td>
                <td [class.unknown]="device.name === 'No Name'">{{device.name}}</td>
                <td> <span [ngClass]="device.is_online ? 'online' : 'offline'">{{device.is_online ? 'Online' : 'Offline'}}</span></td>
                <td>
                  <div [ngClass]="device.videoai_enabled ? device.provider_name : ''">{{device.provider_name}}</div>
                </td>
                <td>{{device.video_events ?? 0}}</td>
                <td>{{device.ai_true_alarm ?? 0}}</td>
                <td>{{device.ai_false_alarm ?? 0}}</td>
                <td>{{device.ai_request ?? 0}}</td>
                <td *ngIf="isBillableMonth">{{device.ai_billable ?? 0}}</td>
                <td>
                  <div class="more-content v-center" #deviceActionMenus *ngIf="tab === 'devices'" [id]="device.device_id" (mouseover)="setMorePosition(device.device_id)">
                    <div class="more-selector" (click)="$event.stopPropagation();toggleMenu(device)">
                      <comp-icon [icon]="'more_horiz'" [size]="20" [color]="'hsla(0, 0%, 0%, 0.87)'"></comp-icon>
                    </div>
                    <div class="more" [class.show]="device.isShowMenu" [id]="'more-'+device.device_id">
                      <div class="more-item pointer row" (click)="$event.stopPropagation();goToCamera(device)">
                        <div>Go to Device</div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <!-- SLOT : pagination-->
      <ng-content></ng-content>
    </div>
  </div>
</ng-container>